import { IconActionMinus24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { ControlButton } from '../ControlButton';

import styles from './ZoomOut.css';

type ZoomOutProps = {
  handleClick: VoidFunction;
};

export const ZoomOut: FC<ZoomOutProps> = props => {
  const { handleClick } = props;

  return (
    <ControlButton
      className={styles['button']}
      handleClick={handleClick}
      icon={<IconActionMinus24 color="icon-primary-default" />}
      testId="map-controls.zoom-out"
    />
  );
};
